import type * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * A 28px input at 13px. No shadow and no ring: the hairline darkens on focus and
 * the global `:focus-visible` outline does the rest, which is one focus language
 * for buttons, links, rows and fields alike.
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'border-line-2 placeholder:text-fg-3 h-7 w-full min-w-0 rounded-md border bg-transparent px-2 text-sm',
        'transition-colors duration-100 outline-none',
        'hover:border-line-2 focus:border-accent-line',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

/** The same treatment, for a goal or a plan note that needs more than one line. */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-line-2 placeholder:text-fg-3 w-full min-w-0 resize-y rounded-md border bg-transparent px-2 py-1.5 text-sm',
        'transition-colors duration-100 outline-none focus:border-accent-line',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

export { Input, Textarea };
